import { useQuery } from '@tanstack/vue-query'
import { ONE_HOUR_MS } from '@shared/utils'
import { getSlicealAccount } from '../fiatWalletEndpoints'
import { fiatWalletKeys } from '../fiatWalletQueryKeys'

export function useSlicealAccountQuery() {
  return useQuery({
    queryKey: fiatWalletKeys.slicealAccount(),
    queryFn: getSlicealAccount,
    staleTime: ONE_HOUR_MS,
  })
}
